// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__vb78O","wrapperNotFound":"styles_wrapperNotFound__lFEEA","title":"styles_title__XUHPB","sliderWrap":"styles_sliderWrap__vVphp","sliderWrapper":"styles_sliderWrapper__ygCRc"};
module.exports.__checksum = "894df0d5143a"
